module.exports = __webpack_public_path__ + "img/ilustracao_completa.96e22453.svg";